export const locale = {
  cancel: 'Cancel',
  steps: 'Record Steps',
  header: 'Record Entry',
  fitness: 'Record Fitness Activity',
  sub_header: 'Required field',
};
